import React, {useState} from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {AppBar, Box, FormControlLabel, Grid, Typography} from '@material-ui/core';

import {
    EfeAutocomplete,
    EfeButtonPrimary,
    EfeButtonSecondary,
    EfeCheckbox,
    EfeSupportMessage,
} from 'components';
import * as colors from 'assets/theme/colors';
import {CatalogValueShape} from 'commons/shapes';
import {AppBarStyles} from 'assets/tss/commons';
import {InferPropTypes} from 'commons/types/Types';
import {MainContent} from 'layouts/commons';
import {RegisterValues} from 'commons/models';
import {ReactComponent as Download} from 'assets/icons/button/action/download.svg';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {setTooltip} from 'hooks/useTooltip';

InnerFormRegister.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    personType: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(CatalogValueShape).isRequired,
};

function InnerFormRegister(
    props: InferPropTypes<typeof InnerFormRegister.propTypes & FormikProps<RegisterValues>>
) {
    const {
        handleChange,
        handleBlur,
        values,
        options,
        isLoading,
        personType,
        isSubmitting,
        setFieldValue,
    } = props;
    const {fatherKycId} = useMenuContext();
    const [activeDownload, setActiveDownload] = useState<boolean>(
        values.personType && values.personType.length
    );

    const classes = AppBarStyles();

    function handleAction(download: boolean) {
        setFieldValue('download', download);
    }

    function handleValue(value: any) {
        setFieldValue('personType', value as string);
        setActiveDownload(value !== undefined && value !== null);
    }

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='InnerFormRegister'>
            <Form noValidate>
                <MainContent>
                    <Box mt={4}>
                        <Typography variant='body1' color='textPrimary'>
                            {'Para comenzar, elige el tipo de persona jur\u00eddica que vas a dar de alta. ' +
                                'Despu\u00e9s descarga el manual de instrucciones para agilizar el llenado del formulario.'}
                        </Typography>
                    </Box>
                    <Box mt={16}>
                        <EfeSupportMessage />
                    </Box>
                    <Grid container direction='column'>
                        <Grid item xs={12}>
                            <Box gridGap={2} display={'flex'} flexDirection='row'>
                                <Grid item xs={6} sm={6} md={6}>
                                    {options && options.length && (
                                        <EfeAutocomplete
                                            labelText='Tipo de persona *'
                                            name='personType'
                                            id='personType'
                                            selectedValue={values.personType}
                                            required
                                            disabled={!!personType}
                                            loading={isLoading}
                                            options={options}
                                            onValueChange={(value: any) => handleValue(value)}
                                            onBlur={handleBlur}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={3} sm={3} md={3}>
                                    <Box
                                        gridGap={2}
                                        display={'flex'}
                                        flexDirection='row'
                                        justifyContent='center'
                                        alignContent='center'
                                        alignSelf={'center'}>
                                        <FormControlLabel
                                            control={
                                                <EfeCheckbox
                                                    name='foreign'
                                                    id='foreign'
                                                    disabled={!!personType}
                                                    onChange={handleChange}
                                                    checked={values.foreign}
                                                />
                                            }
                                            label={'Extranjero'}
                                        />
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </MainContent>
                <AppBar position='fixed' color='primary' className={classes.appBar}>
                    <MainContent>
                        <Grid container direction='row' justifyContent='center'>
                            <Box m={2} display={'flex'}>
                                <Box width={320} mr={16}>
                                    <EfeButtonSecondary
                                        fullWidth
                                        type='submit'
                                        disabled={!activeDownload}
                                        onClick={() => handleAction(true)}
                                        variant='outlined'
                                        endIcon={
                                            <Download
                                                fill={colors.secondary.A02}
                                                stroke={colors.neutrals.A10}
                                            />
                                        }>
                                        {'Descargar Manual'}
                                    </EfeButtonSecondary>
                                </Box>
                                {setTooltip(
                                    <Box width={320}>
                                        <EfeButtonPrimary
                                            fullWidth
                                            disabled={isSubmitting || fatherKycId !== 0}
                                            type='submit'
                                            onClick={() => handleAction(false)}
                                            endIcon={<CallMade />}>
                                            {'Guardar  Y Continuar'}
                                        </EfeButtonPrimary>
                                    </Box>,
                                    !!personType,
                                    'Se ha habilitado el men\u00FA de navegaci\u00F3n.',
                                    'top'
                                )}
                            </Box>
                        </Grid>
                    </MainContent>
                </AppBar>
            </Form>
        </div>
    );
}

export default InnerFormRegister;
